import React from 'react';
import TableData from './components/tableData';

export default function SavingPlanVariant() {
  return <TableData />;
}
